import "./topbar.scss";
import {
    FileCopyOutlined,
    FolderOutlined,
    HomeOutlined,
    InfoOutlined,
    PermContactCalendarOutlined
} from "@material-ui/icons";
import React from "react";

export default function Topbar({menuOpen,setMenuOpen}){
    return (
        <div className={"topbar " + (menuOpen && "active")}>
            <div className="wrapper">
                <div className="left">
                    <a href="#home" className="logo"><img src={"assets/lesty-icon.png"} alt={"icon"} className={"icon"}/>Pierre B.</a>
                </div>
                <div className="right">
                    <a href="#home">
                    <div className="to-top item-container couleur-remplissage">
                        <HomeOutlined className={"icon"} />
                        <p>Accueil</p>
                    </div></a>
                    <a href="#intro">
                    <div className="to-top item-container couleur-remplissage">
                        <InfoOutlined className={"icon"} />
                        <p>A propos</p>
                    </div></a>
                    <a href="#portfolio">
                    <div className="to-top item-container couleur-remplissage">
                        <FolderOutlined className={"icon"} />
                        <p>Mes projets</p>
                    </div></a>
                    <a href="#contact">
                    <div className="to-top item-container couleur-remplissage">
                        <PermContactCalendarOutlined className={"icon"} />
                        <p>Contact</p>
                    </div></a>
                    <div className={"hamburger-menu"} onClick={()=>{ setMenuOpen(!menuOpen)}}>
                        <span className={"line1"}></span>
                        <span className={"line2"}></span>
                        <span className={"line3"}></span>
                    </div>
                </div>
            </div>
        </div>
    )
}